<template>
  <svg
    width="120"
    height="24"
    viewBox="0 0 120 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="117.916" height="24" fill="#004280" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.5903 20.4671V7.8623H28.7879C33.8735 7.8623 36.2343 10.7575 36.2343 14.2735C36.2343 17.7839 33.6639 20.4671 29.3367 20.4671H26.5903ZM29.4247 10.3119V17.8951C32.1231 18.0687 33.4191 16.4471 33.4191 14.3239C33.4191 12.1063 32.1815 10.1615 29.4247 10.3119Z"
      fill="white"
    />
    <path
      d="M64.884 7.86266H62.0432V14.8579L54.2896 7.64746V20.4675H57.1256V13.8939L64.884 20.9803V7.86266Z"
      fill="white"
    />
    <path
      d="M66.0938 10.3095H69.5537V20.4671H72.6009V10.3095H76.0201V7.8623H66.0938V10.3095Z"
      fill="white"
    />
    <path
      d="M77.1343 20.4671V7.8623H84.5655V10.2543H79.9927V12.9399H84.1087V15.3671H79.9927V18.0511H84.5655V20.4671H77.1343Z"
      fill="white"
    />
    <path
      d="M104.317 7.8623V12.9575H99.4465V7.8623H96.6025V20.4671H99.4465V15.3671H104.317V20.4671H107.159V7.8623H104.317Z"
      fill="white"
    />
    <path
      d="M34.8633 7.8623L41.3161 20.8127L42.8689 17.5255L38.1633 7.8623H34.8633Z"
      fill="white"
    />
    <path
      d="M47.7137 7.42676L46.1497 10.698L47.4793 14.0644H44.5329L43.5425 16.1484H48.2897L50.0825 20.4676H53.3801L47.7137 7.42676Z"
      fill="white"
    />
    <path
      d="M85.1753 14.1906C85.1753 18.3234 88.2897 20.621 92.1305 20.621C93.6465 20.621 94.4841 20.1858 95.1137 19.8626V16.8738C94.5305 17.6474 93.3649 18.1634 92.1865 18.1634C89.8865 18.1634 88.0617 16.6098 88.0617 14.1138C88.0617 11.6426 90.0857 10.161 92.1865 10.161C93.3657 10.161 94.5313 10.677 95.1137 11.4506V8.68016C94.5761 8.20736 93.6089 7.80176 92.0969 7.80176C88.2585 7.80176 85.1753 10.5234 85.1753 14.1906Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.6807 4.72168L25.9023 20.4673H22.1927L21.1567 17.8329H15.9879L14.9591 20.4673H11.3911L18.6807 4.72168ZM18.5759 11.0745L16.7639 15.5281H20.3879L18.5759 11.0745Z"
      fill="white"
    />
  </svg>
</template>
